import React, { useEffect, useState } from "react";
import SkeletonTable from "../../../components/table/SkeletonTable";
import columns from "../../../columns/reports/allAuditReport";
import { GetAllAuditReportApi } from "../../../api/request/reports/report";

const AuditReport = () => {
  const [auditData, setAuditData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getAllAuditReports = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetAllAuditReportApi();
      if (data?.status) {
        setAuditData(data?.data);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllAuditReports();
  }, []);

  return (
    <div className="border-2 rounded-xl my-5">
      <div className="flex justify-between mx-5 mt-5">
        <p className="font-semibold text-2xl">Audit Report</p>
      </div>
      <div className="my-6">
        <SkeletonTable
          columns={columns}
          searchingFields={["client_name"]}
          data={auditData}
          isLoading={isLoading}
          pagination={{ pageSize: 100 }} />
      </div>
    </div>
  );
};

export default AuditReport;
